import { Routes } from '@angular/router';

import { afterLoginGuard } from './common/guards/after-login/after-login.guard';
import { beforeLoginGuard } from './common/guards/before-login/before-login.guard';

import { ngxPermissionsGuard } from 'ngx-permissions';
import { ModulesPermissions } from './common/interfaces/menu.interface';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./guests/login/login').then((m) => m.Login),
    canActivate: [beforeLoginGuard],
  },
  {
    path: 'ngao-callback',
    loadComponent: () =>
      import('./guests/ngao-callback/ngao-callback').then(
        (m) => m.NgaoCallback,
      ),
    canActivate: [beforeLoginGuard],
  },
    {
    path: 'ngao-callback-after-login',
    loadComponent: () =>
      import('./guests/ngao-callback/ngao-callback').then(
        (m) => m.NgaoCallback,
      ),
    canActivate: [afterLoginGuard],
  },

  {
    path: 'activate',
    loadComponent: () =>
      import('./guests/activation-reset/activation-reset').then(
        (m) => m.ActivationReset
      ),
    canActivate: [beforeLoginGuard],
    data: {
      forActivation: true,
    },
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./guests/activation-reset/activation-reset').then(
        (m) => m.ActivationReset
      ),
    canActivate: [beforeLoginGuard],
    data: {
      forActivation: false,
    },
  },
  {
    path: '',
    canActivate: [afterLoginGuard],
    loadComponent: () =>
      import('./shared/layout/auth-shell/auth-shell').then((m) => m.AuthShell),
    children: [
      {
        path: 'home',
        canActivate: [ngxPermissionsGuard],
        loadChildren: () =>
          import('./modules/home/home.routes').then((m) => m.HOME_ROUTES),
        data: {
          permissions: {
            only: ModulesPermissions.home,
            redirectTo: 'login',
          },
        },
      },
      {
        path: 'settings',
        canActivate: [ngxPermissionsGuard],
        loadChildren: () =>
          import('./modules/settings/settings.routes').then(
            (m) => m.SETTING_ROUTES
          ),
        data: {
          permissions: {
            only: ModulesPermissions.settings,
            redirectTo: 'home',
          },
        },
      },
      {
        path: 'users',
        canActivate: [ngxPermissionsGuard],
        loadChildren: () =>
          import('./modules/users/users.routes').then((m) => m.USERS_ROUTES),
        data: {
          permissions: {
            only: ModulesPermissions.users,
            redirectTo: 'home',
          },
        },
      },
      {
        path: 'configurations',
        canActivate: [ngxPermissionsGuard],
        loadChildren: () =>
          import('./modules/configurations/configurations.routes').then(
            (m) => m.CONFIG_ROUTES
          ),
        data: {
          permissions: {
            only: ModulesPermissions.configurations,
            redirectTo: 'home',
          },
        },
      },
      {
        path: 'gateway',
        canActivate: [ngxPermissionsGuard],
        loadChildren: () =>
          import('./modules/gateway/gateway.routes').then(
            (m) => m.GATEWAY_ROUTES
          ),
        data: {
          permissions: {
            only: ModulesPermissions.gateway,
            redirectTo: 'home',
          },
        },
      },
      {
        path: 'cases',
        canActivate: [ngxPermissionsGuard],
        loadChildren: () =>
          import('./modules/cases/cases.routes').then((m) => m.CASES_ROUTES),
        data: {
          permissions: {
            only: ModulesPermissions.cases,
            redirectTo: 'home',
          },
        },
      },
      {
        path: 'inmates',
        canActivate: [ngxPermissionsGuard],
        loadChildren: () =>
          import('./modules/inmates/inmates.routes').then(
            (m) => m.INMATES_ROUTES
          ),
        data: {
          permissions: {
            only: ModulesPermissions.inmates,
            redirectTo: 'home',
          },
        },
      },
      {
        path: 'reports',
        canActivate: [ngxPermissionsGuard],
        loadChildren: () =>
          import('./modules/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
        data: {
          permissions: {
            only: ModulesPermissions.reports,
            redirectTo: 'home',
          },
        },
      },
    ],
  },

  {
    path: '**',
    redirectTo: 'login',
  },
];
